import axios from 'axios'
import {AuthModel} from './_models'
import {API_URL} from '../../../../_metronic/helpers'
import {getAuth} from './AuthHelpers'
import {TAB_BUSINESS_QUERY, requestedTabBusiness} from './tabBusiness'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/verify`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// // Server should return AuthModel
// export function login(_username: string, _password: string, captcha: string, browser: object) {
//   const username = CryptoJS.AES.encrypt(_username, key + 'uusr')
//   const password = CryptoJS.AES.encrypt(_password, key + 'ppsw')
//   return axios.post<AuthModel>(LOGIN_URL, {
//     username,
//     password,
//     captcha,
//     browser,
//   })
// }

// Server should return AuthModel
// export function register(
//   email: string,
//   firstname: string,
//   lastname: string,
//   password: string,
//   password_confirmation: string
// ) {
//   return axios.post(REGISTER_URL, {
//     email,
//     first_name: firstname,
//     last_name: lastname,
//     password,
//     password_confirmation,
//   })
// }

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token = '') {
  const supportToken = getAuth()?.tk
  const isSupport = Boolean(supportToken && (!token || token === supportToken))
  const requestedToken = token || supportToken || ''
  // The tab's business, in the address (the header is sent only after this answer says the server reads it). A sign-in
  // that names its token opens the business the sign-in chose.
  const tabBusiness = isSupport || token ? undefined : requestedTabBusiness()
  const verifyUrl = isSupport
    ? `${API_URL}/support-sessions/verify`
    : tabBusiness === undefined
      ? GET_USER_BY_ACCESSTOKEN_URL
      : `${GET_USER_BY_ACCESSTOKEN_URL}?${TAB_BUSINESS_QUERY}=${tabBusiness}`
  return axios.post<AuthModel>(
    verifyUrl,
    requestedToken
      ? {
          tk: requestedToken,
        }
      : {}
  )
}

// «ورود موقت با این کاربر» (api/taxpayer/users/login) was retired 2026-10-29: everyone works under their own account,
// and support staff enter a business through the CRM's «ورود پشتیبان» (supportsso).
